module.exports = __webpack_public_path__ + "img/first_three.9ed9070c.png";